import React, { type ReactNode, useEffect, useState } from 'react';
import { ChoreographerContextProvider } from '@atlassian/jira-choreographer-services/src/ChoreographerContextProvider.tsx';
import type { ChoreographerMessageTypes } from '@atlassian/jira-choreographer-services/src/types.tsx';

import { getTenantContext_DEPRECATED_DO_NOT_USE } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import { CoordinationClient } from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';

const STARGATE_URL = '/gateway/api';

type Props = {
	messageId: string;
	messageType: ChoreographerMessageTypes;
	fallback: ReactNode;
	children: ReactNode;
};

export const CoordinationClientWithFallback = ({
	messageId,
	messageType,
	fallback,
	children,
}: Props) => {
	const { cloudId } = getTenantContext_DEPRECATED_DO_NOT_USE();
	const { data: orgId } = useOrgId();
	const [coordinationClient] = useState(
		new CoordinationClient(cloudId, STARGATE_URL, false, orgId, messageType),
	);
	const [didMessageStart, setDidMessageStart] = useState<boolean | undefined>(undefined);

	useEffect(() => {
		coordinationClient.start(messageId).then(setDidMessageStart);
	}, [coordinationClient, messageId]);

	switch (didMessageStart) {
		case true:
			return (
				<ChoreographerContextProvider isChoreographed={coordinationClient.enableChoreographer}>
					{children}
				</ChoreographerContextProvider>
			);
		case false:
			return <>{fallback}</>;
		default:
			return null;
	}
};
